import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

import {constants as destinationConstants} from '@eb/destination-utils';

import {SUGGESTIONS_PROPTYPE} from '../constants';
import SearchInput from './SearchInput';
import FacetedSearchFiltersWrapped from './FacetedSearchFilters';
import FacetedSearchFiltersNewSearch from './FacetedSearchFiltersNewSearch';

const {LOCATION_DIALOG_CONTENT} = destinationConstants;

export default class SearchHeader extends PureComponent {
    static propTypes = {
        /*
         * From withOverlayControls HoC
         */
        showOverlay: PropTypes.func.isRequired,
        hideOverlay: PropTypes.func,
        addOverlayNotification: PropTypes.func,
        hideOverlayNotification: PropTypes.func,
        trackGAEvent: PropTypes.func,
        handleApplyFilter: PropTypes.func,
        handleRemoveFilter: PropTypes.func,
        searchHeaderTitle: PropTypes.string,
        selectedCategory: PropTypes.string,
        selectedPrice: PropTypes.string,
        selectedDate: PropTypes.string,
        selectedFormat: PropTypes.string,
        isBotRequest: PropTypes.bool,
        currentPlace: PropTypes.string,
        term: PropTypes.string,
        locationSlug: PropTypes.string,
        locationDenied: PropTypes.bool,
        suggestions: SUGGESTIONS_PROPTYPE,
        handleUseCurrentLocation: PropTypes.func,
        handleSearchSuggestionChange: PropTypes.func,
        handleLocationSuggestionChange: PropTypes.func,
        handleLocationSelect: PropTypes.func,
        onGoogleMapsLoaded: PropTypes.func,
        isLoading: PropTypes.bool,
        facets: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.string,
            count: PropTypes.number,
            displayName: PropTypes.string,
        })),
    }

    componentDidUpdate(prevProps) {
        const {
            locationDenied,
            showOverlay,
        } = this.props;

        if (locationDenied !== prevProps.locationDenied) {
            showOverlay(
                'dialog',
                LOCATION_DIALOG_CONTENT
            );
        }
    }

    _onUseCurrentLocation = () => {
        const {
            handleUseCurrentLocation,
            showOverlay,
            locationDenied,
        } = this.props;

        if (locationDenied) {
            return showOverlay(
                'dialog',
                LOCATION_DIALOG_CONTENT
            );
        }

        return handleUseCurrentLocation();
    }

    render() {
        const {
            searchHeaderTitle,
            selectedCategory,
            selectedPrice,
            selectedDate,
            handleRemoveFilter,
            isBotRequest,
            locationSlug,
            currentPlace,
            term,
            handleSearchSuggestionChange,
            handleLocationSuggestionChange,
            handleApplyFilter,
            selectedFormat,
            suggestions,
            facets,
            isLoading,
            trackGAEvent,
            handleLocationSelect,
            onGoogleMapsLoaded,
            location,
            history,
            isNewSearch,
            openCloseFilterPanelMobile,
        } = this.props;

        let headerContent = (
            <SearchInput
                hasHistory={true}
                handleSearchSuggestionChange={handleSearchSuggestionChange}
                handleLocationSuggestionChange={handleLocationSuggestionChange}
                handleUseCurrentLocation={this._onUseCurrentLocation}
                handleApplyFilter={handleApplyFilter}
                initialSearchQuery={term}
                currentPlace={currentPlace}
                suggestions={suggestions}
                trackGAEvent={trackGAEvent}
                handleLocationSelect={handleLocationSelect}
                onGoogleMapsLoaded={onGoogleMapsLoaded}
                location={location}
                history={history}
            />
        );

        // for bots we will just show the title
        if (isBotRequest) {
            headerContent = (
                <h1 className="eds-text-hm eds-text-color--grey-700 search-header__bot-friendly">
                    {searchHeaderTitle}
                </h1>
            );
        }

        const newSearchFilters = (
            <FacetedSearchFiltersNewSearch
                selectedDate={selectedDate}
                selectedCategory={selectedCategory}
                selectedPrice={selectedPrice}
                selectedFormat={selectedFormat}
                isBotRequest={isBotRequest}
                locationSlug={locationSlug}
                facets={facets}
                isLoading={isLoading}
                trackGAEvent={trackGAEvent.bind(this)}
                history={history}
                isNewSearch={isNewSearch}
                openCloseFilterPanelMobile={openCloseFilterPanelMobile}
            />
        );

        const oldSearchFilters = (
            <FacetedSearchFiltersWrapped
                selectedDate={selectedDate}
                selectedCategory={selectedCategory}
                selectedPrice={selectedPrice}
                selectedFormat={selectedFormat}
                handleApplyFilter={handleApplyFilter}
                handleRemoveFilter={handleRemoveFilter}
                isBotRequest={isBotRequest}
                locationSlug={locationSlug}
                facets={facets}
                isLoading={isLoading}
                trackGAEvent={trackGAEvent.bind(this)}
                history={history}
            />
        );

        let headerToShow = newSearchFilters;

        if (isBotRequest) {
            // Old search filters are still being used for SEO
            headerToShow = oldSearchFilters;
        }

        if (!isNewSearch) {
            headerToShow = oldSearchFilters;
        }

        return (
            <header className="search-header">
                <div className="eds-l-pad-left-3 eds-l-pad-bot-2">
                    {headerContent}
                </div>
                {headerToShow}
            </header>
        );
    }
}
